import { observer, inject } from "mobx-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import { Text } from "../../UI";
import { InnerBox } from "../Common";
import PhotosWidget from "../PhotosWidget";

const TextItem = ({ value, label, isNew }) => {
  const theme = useTheme();

  return (
    <InnerBox
      style={{
        padding: 10,
        flexBasis: "35%",
      }}
    >
      <Text.SR
        color={!isNew ? theme.color.gray70 : theme.color.gray90}
        style={{
          textAlign: "start",
        }}
      >
        {label}
      </Text.SR>
      <Text.SM color={theme.color.navy} style={{ textAlign: "start" }}>
        {value}
      </Text.SM>
    </InnerBox>
  );
};

const MobileNewDefect = ({ defect = {}, department }) => {
  const { t } = useTranslation("applies");

  const [extFiles, setExtFiles] = useState(
    !!defect?.ZCOB_DEFECTSLISTPIC_SUBFORM && !!defect.EXTFILENAME
      ? [
          { EXTFILENAME: defect.EXTFILENAME },
          ...defect?.ZCOB_DEFECTSLISTPIC_SUBFORM,
        ]
      : !!defect.EXTFILENAME
      ? [{ EXTFILENAME: defect.EXTFILENAME }]
      : []
  );

  return (
    <div
      style={{
        width: "100%",
        height: "60vh",
        overflowY: "auto",
        backgroundColor: "rgb(255, 255, 255)",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          alignItems: "start",
          width: "100%",
          gap: 8,
          padding: 0,
        }}
      >
        <TextItem
          value={defect.KLINE}
          label={t("kline")}
          style={{ padding: 0 }}
        />
        <TextItem
          value={defect.SITEAREADES}
          label={t("area")}
          style={{ padding: 0 }}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "start",
          width: "100%",
          gap: 8,
          padding: 0,
        }}
      >
        <TextItem
          value={defect.LOCATIONDES}
          label={t("location")}
          style={{ padding: 0 }}
        />
        <TextItem
          value={defect.CHKPERIODTYPEDES}
          label={t("domain")}
          style={{ padding: 0 }}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 12,
          padding: 0,
          alignItems: "start",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <div>
          <TextItem
            style={{ paddingTop: 0, flexBasis: "50%" }}
            value={
              !!defect.DEFECTDES
                ? `${!!defect.DEFECTDES ? defect.DEFECTDES : ``} ${
                    !!defect?.ZCOB_DEFECTSLISTTEXT_SUBFORM?.TEXT
                      ? defect?.ZCOB_DEFECTSLISTTEXT_SUBFORM?.TEXT
                      : ``
                  }`
                : ``
            }
            label={t("defect_description")}
          />
        </div>
      </div>
      <div style={{ padding: "10px 20px" }}>
        <PhotosWidget
          limit={5}
          isEdit={false}
          photosList={extFiles}
          setPhotos={setExtFiles}
          isMobile={true}
        />
      </div>
    </div>
  );
};

export default inject("repairPagesStore")(observer(MobileNewDefect));
